import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Input,
  makeStyles
} from "@fluentui/react-components";
import { FormattedMessage, useIntl } from "react-intl";
import { Dismiss24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  textField: {
    width: "100%"
  }
});

export function RenameAvatarDialog({ avatarId, currentName, open, onOpenChange, onSave }) {
  const intl = useIntl();
  const styles = useStyles();

  const [name, setName] = useState(currentName || "");

  useEffect(() => {
    if (open) {
      setName(currentName || "");
    }
  }, [open, currentName]);

  const handleChangeName = useCallback(e => {
    setName(e.target.value);
  }, []);

  const handleSave = () => {
    onSave({ avatar_id: avatarId, name });
    onOpenChange(null, { open: false });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                aria-label={intl.formatMessage({ id: "room-settings-sidebar.close-button", defaultMessage: "Close" })}
                icon={<Dismiss24Regular />}
                onClick={() => onOpenChange(null, { open: false })}
              />
            }
          >
            <FormattedMessage id="avatar-editor.rename-avatar-button" defaultMessage="Rename avatar" />
          </DialogTitle>
          <DialogContent>
            <Input
              appearance="filled-darker"
              required
              value={name}
              onChange={handleChangeName}
              placeholder={intl.formatMessage({
                id: "avatar-editor.field.avatar-name",
                defaultMessage: "Avatar name"
              })}
              className={styles.textField}
            />
          </DialogContent>
          <DialogActions>
            <Button appearance="outline" onClick={() => onOpenChange(null, { open: false })}>
              <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
            </Button>
            <Button appearance="primary" onClick={handleSave} disabled={!name || name === currentName}>
              <FormattedMessage id="avatar-editor.submit-button.save" defaultMessage="Save" />
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

RenameAvatarDialog.propTypes = {
  avatarId: PropTypes.string,
  currentName: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  onSave: PropTypes.func
};
